import type { Translations } from "../types";

const pt: Translations = {
  "meta.title": "Mapa de Cliques por País",
  "meta.description":
    "Mapa mundial interativo: cliques gratuitos por país além de apoio pago via Stripe, PayPal e Buy Me a Coffee.",

  "app.title": "Mapa de Cliques por País",

  "map.intro":
    "Clique em um país no mapa para dar a ele um voto gratuito, ou envie apoio financeiro - ambos contam para a classificação combinada abaixo. O mapa reflete apenas o apoio dentro deste app, não a riqueza nacional real ou o PIB.",
  "map.verifying": "Verificando …",
  "map.confirmNotRobot": "Antes de adicionar cliques gratuitos, confirme rapidamente que você não é um robô:",
  "map.tryAgain": "Tentar novamente",
  "map.registeringClick": "Registrando clique …",
  "map.selectedCountry": "País selecionado: {name}.",
  "map.selectFirstFeedback": "País selecionado. Para adicionar um clique gratuito, confirme primeiro abaixo que você não é um robô.",
  "map.verificationExpired": "A verificação expirou - confirme novamente que você não é um robô.",
  "map.slowDown": "Um pouco mais devagar - aguarde um momento antes do próximo clique.",
  "map.clickFailed": "Não foi possível registrar o clique. Tente novamente.",
  "map.clickErrorGeneric": "Erro ao registrar o clique.",
  "map.leaderboardHeading": "Classificação de Países",
  "map.emptySelection": "Selecione um país no mapa para votar ou apoiar.",
  "map.loadingData": "Carregando dados …",

  "worldmap.loadError": "Não foi possível carregar o mapa.",
  "worldmap.resetZoom": "Redefinir zoom",
  "worldmap.resetButton": "⤾ Redefinir",
  "worldmap.loadingMap": "Carregando mapa …",
  "worldmap.unknownCountry": "Desconhecido",
  "worldmap.ariaClicks": "{name}: {clicks} cliques",
  "worldmap.tooltipClicks": "{clicks} cliques",

  "legend.fewer": "Menos cliques",
  "legend.more": "Mais cliques",

  "list.empty": "Ainda não há cliques. Seja o primeiro!",
  "list.ariaLabel": "Classificação de países por cliques",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY não está definida - consulte o README para configuração.",
  "human.verificationFailedGeneric": "Falha na verificação.",
  "human.networkError":
    "Não foi possível alcançar a verificação (erro de rede) - verifique VITE_SUPABASE_URL, se verify-human está implantada, e ALLOWED_ORIGIN; consulte README/NAVODILA.",
  "human.verificationFailedRetry": "Falha na verificação, tente novamente.",

  "provider.stripe": "💳 Cartão (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "País selecionado",
  "panel.currentlyRanked": "Atualmente na posição #{rank}",
  "panel.shareCopied": "Copiado ✓",
  "panel.shareShared": "Compartilhado ✓",
  "panel.shareButton": "🔗 Compartilhar",

  "panel.tableClicks": "Cliques",
  "panel.tableFree": "Gratuito",
  "panel.tablePaid": "Pago",
  "panel.rowAllTime": "Total geral",
  "panel.rowThisYear": "Este ano",
  "panel.rowThisWeek": "Esta semana",
  "panel.rowToday": "Hoje",

  "panel.totalCombined": "Total combinado:",
  "panel.totalSupport": "Apoio total:",

  "panel.paymentMethod": "Forma de pagamento",
  "panel.noPaymentMethod": "Nenhuma forma de pagamento está disponível no momento.",
  "panel.supportAmount": "Valor do apoio (EUR)",
  "panel.amountRange": "O valor deve estar entre {min} e {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Cliques pagos estimados:",
  "panel.ratioInfo":
    "Proporção: {a} = {b} cliques (ex.: {c} = {d} cliques). Isso é apenas uma estimativa antes do pagamento - o número final de cliques é sempre calculado e confirmado pelo servidor com base no pagamento efetivamente confirmado.",
  "panel.preparing": "Preparando …",
  "panel.continueWith": "Continuar com {provider}",
  "panel.choosePaymentMethod": "Escolha uma forma de pagamento",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME não está definida - consulte o README para configuração.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID não está definida - consulte o README para configuração.",

  "panel.paypalAmountInfo": "Valor: {amount} (estimado {clicks} cliques). Conclua o pagamento com o botão do PayPal abaixo.",
  "panel.back": "← Voltar",

  "panel.bmcWarningTitle": "⚠️ Antes de continuar para o BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Cole o código abaixo no campo de mensagem/nota no checkout — é a única forma de sabermos qual país você está apoiando. Sem o código, não podemos atribuir o pagamento a nenhum país.",
  "panel.copy": "Copiar",
  "panel.copied": "Copiado ✓",
  "panel.suggestedAmount": "Valor sugerido:",
  "panel.bmcAmountNote":
    "(estimado {clicks} cliques). Infelizmente o BuyMeCoffee não permite transferir o valor pelo link — insira/selecione você mesmo no site deles. O número real de cliques é sempre calculado a partir do valor que você realmente enviar no BuyMeCoffee, não desta estimativa.",
  "panel.openBmc": "Abrir BuyMeCoffee e continuar →",
  "panel.waitingProvider": "Aguardando confirmação de pagamento do provedor de pagamento …",
  "panel.waitingConfirmation": "Aguardando confirmação de pagamento …",
  "panel.timedOut":
    "A verificação expirou. Se você concluiu o pagamento, o mapa será atualizado assim que o servidor receber a confirmação - isso às vezes pode demorar um pouco mais.",
  "panel.checkAgain": "Verificar novamente",

  "panel.cancelled": "O pagamento foi cancelado ou não foi concluído. O mapa não mudou.",
  "panel.tryAgain": "Tentar novamente",

  "panel.confirmed": "✅ Apoio confirmado!",
  "panel.confirmedBody": "{country} recebeu {clicks} cliques pagos por {amount}.",

  "panel.errorPreparingSupport": "Erro ao preparar seu apoio.",
  "panel.errorPreparingPayment": "Erro ao preparar o pagamento.",
  "panel.errorConfirmingPayment": "Erro ao confirmar o pagamento.",
  "panel.errorPayingPaypal": "Erro ao pagar com PayPal.",

  "share.unranked": "{flag}{country} precisa do seu apoio no mapa mundial!\nAjude a subir na classificação 👇",
  "share.rank1": "{flag}{country} está atualmente em #1!\nAjude-nos a continuar no topo 👇",
  "share.rankN": "{flag}{country} está atualmente em #{rank}!\nAjude-nos a chegar ao #1 👇",

  "language.switcherLabel": "Idioma",
};

export default pt;
